import TYPES from '@/types';
import i18n from '@/vue-app/plugins/i18n';

// Application
import {
  GetFundingDetailsQuery,
} from '@/modules/my-investment/kuspit/funding-details/application/queries';
import CustomerOverviewService from '@/modules/home-dashboard/customer-overview/application/services/customer-overview-service';

// Domain
import CustomerOverviewState from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';
import Inject from '@/modules/shared/domain/di/inject';

export default class FundingDetailsKuspitAccountViewModel {
  @Inject(TYPES.CUSTOMER_OVERVIEW_SERVICE)
  private readonly customer_overview_service!: CustomerOverviewService;

  @Inject(TYPES.GET_KUSPIT_FUNDING_DETAILS_QUERY)
  private readonly get_funding_details_query!: GetFundingDetailsQuery;

  readonly i18n_namespace = 'components.my-investment-dashboard.fund-kuspit-account';

  kuspit_clabe = '';

  bank_name = '';

  customer_overview: CustomerOverviewState = this.customer_overview_service.get_customer_overview();

  get funding_details() {
    return this.get_funding_details_query.execute();
  }

  translate = (value: string, count?: number, values?: Record<string, string | number>) => (values ? i18n.tc(`${this.i18n_namespace}.${value}`, count, values) as string : i18n.t(`${this.i18n_namespace}.${value}`) as string);

  initialize = async () => {
    if (this.customer_overview.item.pocket_investment_product_overview.contracted) {
      const funding_details_kuspit = await this.funding_details;
      this.kuspit_clabe = funding_details_kuspit.kuspit_clabe;
      this.bank_name = funding_details_kuspit.bank;
    }
  }
}
